import moment from 'moment-timezone';

export function listEquals(c: any, e: any) {
  const conflicting = c || [];
  const existing = e || [];
  if (conflicting.length !== existing.length) return false;
  return conflicting.every((x: any) => existing.includes(x));
}

export function compareEducations(a: any, b: any) {
  if (a.start_date < b.start_date) return 1;
  if (a.start_date > b.start_date) return -1;

  if (a.id > b.id) return 1;
  if (a.id < b.id) return -1;

  return 0;
}

export function compareExperiences(a: any, b: any) {
  if (a.current < b.current) return 1;
  if (a.current > b.current) return -1;

  if (a.start_date < b.start_date) return 1;
  if (a.start_date > b.start_date) return -1;

  if (a.id > b.id) return 1;
  if (a.id < b.id) return -1;

  return 0;
}

export function formatDate(date: any) {
  return date ? moment(date).format('MMM YYYY') : '';
}

export function equalExperience(e: any, c: any) {
  if (e.organization !== c.organization) return false;
  if (e.title !== c.title) return false;
  if (formatDate(e.start_date) !== formatDate(c.start_date)) return false;
  if (formatDate(e.end_date) !== formatDate(c.end_date)) return false;
  if (e.description !== c.description) return false;
  if (e.linkedin_url !== c.linkedin_url) return false;
  if (e.location !== c.location) return false;
  return true;
}

export function equalEducation(e: any, c: any) {
  if (e.school !== c.school) return false;
  if (e.degree !== c.degree) return false;
  if (e.field_of_study !== c.field_of_study) return false;
  if (e.description !== c.description) return false;
  if (formatDate(e.start_date) !== formatDate(c.start_date)) return false;
  if (formatDate(e.end_date) !== formatDate(c.end_date)) return false;
  return true;
}

const parseFormat = 'YYYY-MM-DD';

export function experienceDateToString(d: any) {
  return d && moment(d).format(parseFormat);
}

export function experienceStringToDate(d: any) {
  return d && moment(d, parseFormat).toDate();
}
